import React, {useEffect, useState} from "react";
import {useSelector, visualInspectionItemsActions} from "inbooma-api";
import t from "../../../helpers/t";
import {_getObjectFromArray, in_array} from "../../../../utils/Helper";

const VisualInspectionItemsList = (props) => {
    const { visualInspection, dispatch, locations, language, moment, Biscuit,t,rbac, showNotification } = props;
    const [locationsList,setLocationsList] = useState({});
    const [contingentsList,setContingentsList] = useState({});
    const [init, setInit] = useState(false);
    const [deleteVisualInspectionItemPending, setDeleteVisualInspectionItemPending] = useState(null);
    const _deleteVisualInspectionItem = useSelector(state => state["visual_inspection_items_data"].deleteVisualInspectionItem);
    const _patchVisualInspectionItem = useSelector(state => state["visual_inspection_items_data"].patchVisualInspectionItem);
    const [marked, setMarked] = useState([]);
    const [markCheckedPending, setMarkCheckedPending] = useState(null);
    const [visualInspectionItems, setVisualInspectionItems] = useState(visualInspection.visual_inspection_items);

    useEffect(() => {
        if(!init) {
            if (locations.length > 0) {
                setLocationsList(_getObjectFromArray(locations));
            }
            setInit(true);
        }
    }, []);

    useEffect(() => {
        if(_patchVisualInspectionItem.success === '' || markCheckedPending === null){
            return;
        }
        if(_patchVisualInspectionItem.success === true){
            let clone = [...marked];
            clone.push(_patchVisualInspectionItem.id);
            setMarked(clone);
            let clone2 = [...visualInspectionItems];
            clone2[markCheckedPending].end = _patchVisualInspectionItem.data.end;
            setVisualInspectionItems(clone2);
            showNotification('success',getLocationById(_patchVisualInspectionItem.data.location_id)+': '+getContingentById(_patchVisualInspectionItem.data.contingent_id),t("closed visual inspection for contingent."));
        } else {
            showNotification('warning',null,t(_patchVisualInspectionItem.data?.message));
        }
        setMarkCheckedPending(null);
    },[_patchVisualInspectionItem]);

    useEffect(() => {
        if(deleteVisualInspectionItemPending === null || _deleteVisualInspectionItem.success === ''){
            return;
        }
        if(_deleteVisualInspectionItem.success !== true){
            showNotification('warning',null,_deleteVisualInspectionItem.data.message);
        }
        setDeleteVisualInspectionItemPending(null);
    }, [_deleteVisualInspectionItem]);



    const deleteVisualInspectionItem = (visualInspectionItem,key) => {
        if (confirm(t('really_remove'))) {
            dispatch(visualInspectionItemsActions.deleteVisualInspectionItem(
                {
                    token: Biscuit.get('token'),
                    id: visualInspectionItem.id,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setDeleteVisualInspectionItemPending(key);
        }
    }

    const getLocationById = (id) => {

        if (id === undefined || id == null || locationsList === undefined) return '';

        if (locationsList[id] !== undefined && locationsList[id] != null) return locationsList[id].name;
        else return '';
    };


    const style= {
        borderBottom: '0.4px solid black',
        borderTop: '0.4px solid black',
        paddingTop: '5px',
        paddingBottom: '5px',
        marginTop: '10px',
        paddingLeft: '15px',
        width: '110%'
    };
    const onMarkChecked = (e,item,index) => {
        item.end = moment().format('YYYY-MM-DD HH:MM');
        dispatch(visualInspectionItemsActions.patchVisualInspectionItem(
            {
                token: Biscuit.get('token'),
                id: item.id,
                data: item
            }
        ));
        setMarkCheckedPending(index);
    }
    const now = moment().format('DD.MM.YYYY HH:MM');
    return (
        <>
            <div id={"slots-panel-" + visualInspection.id} className="inb-c-item-details inb-c-contingent-resources row" style={{height:'max-content',width:'80%'}}>
                <header className="inb-c-item-details__header small-12 column">
                    {rbac.hasPermission("write") &&<a href={"visual_inspections/"+visualInspection.id+"/item/add"}
                       className="inb-c-item-add inb-resource-manage small button beautify float-right"
                       data-inb-visual-inspection-id={visualInspection.id}
                       data-inb-action-link="write"> {t('add_${a}',{a:t('visual_inspection_item')})}  </a>}
                    {visualInspectionItems.length === 0 &&
                        <span className="inb-list-title">{t('no_visual_inspection_items')}</span>
                    }
                    {visualInspectionItems.length > 0 &&
                        <span className="inb-list-title">{t('visual_inspection_items') + " " + visualInspection.visual_inspection_items.length}</span>
                    }
                    <div id="inb-c-main-header" className="row" style={style}>
                        <ul className="inb-tabs medium-12">
                            <li className="tabs-title column medium-4" style={{padding:0}}>{t('location')}</li>
                            <li className="tabs-title column medium-3" style={{marginLeft:"-40px"}}>{t('valid_from')}</li>
                            <li className="tabs-title column medium-3" style={{marginLeft:"-25px"}}>{t('valid_to')}</li>
                        </ul>
                    </div>
                </header>
                {visualInspectionItems.map((item,index) => {
                    const markAble = now >= moment(item.begin).format('DD.MM.YYYY HH:MM') && now < moment(item.end).format('DD.MM.YYYY HH:MM');
                    const endReached = now >= moment(item.end).format('DD.MM.YYYY HH:MM');
                    return(
                        <>
                    <div className={"inb-resource inb-c-item-details-row row " +(endReached?"has-form-data":"")} key={item.id}>
                        <div className="medium-4 column inb-visual_inspection__visual_inspection_item_location" title={t('location')}>{getLocationById(item.location_id)}</div>
                        <div className="medium-3 column inb-visual_inspection__visual_inspection_item_begin" style={endReached?{paddingLeft:'35px'}:{}} title={t('valid_from')}>{moment(item.begin).format('HH:mm')}</div>
                        <div className="medium-3 column inb-visual_inspection__visual_inspection_item_end" style={endReached?{paddingLeft:'45px'}:{}} title={t('valid_to')}>{moment(item.end).format('HH:mm')}</div>
                        <div className="medium-2 small-6 medium-offset-0 column item-button-group" style={endReached?{paddingLeft:'35px'}:{}}>
                            { rbac.hasPermission('editVisualInspection') &&
                                <>{!in_array(item.id,marked) && markAble &&
                                    <>
                                        {!markCheckedPending ? <div className="button-container left">
                                    <a
                                        href="#"
                                        title={t('closing')}
                                        onClick={e=>onMarkChecked(e,item,index)}
                                        data-inb-action-link="check">
                                        <button type="button" className="inb-round-btn hollow round float-left">
                                            <div className="inb-fi-check"></div>
                                        </button>
                                    </a>
                                     </div>:<span><img alt="RollingLoader" className="rollingLoader" src={"assets/img/rolling_loader.svg"} /></span>}
                                    </>
                                        }
                                <div className="button-container left">
                                    <a
                                        href={"/visual_inspections/"+visualInspection.id+"/item/"+item.id}
                                        title=""
                                        data-inb-action-link="edit">
                                        <button type="button" className="inb-round-btn hollow round float-left">
                                            <div className="inb-fi-edit"></div>
                                        </button>
                                    </a>
                                </div></>
                            }
                            { rbac.hasPermission('deleteVisualInspection') &&
                                <>
                                    {deleteVisualInspectionItemPending !== index ?
                                        <div className="button-container">
                                            <a
                                                href="#"
                                                className="inb-reservation__pdf2"
                                                title={ t('delete') }>
                                                <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => deleteVisualInspectionItem(item,index)}>
                                                    <div className="inb-fi-remove"></div>
                                                </button>
                                            </a>
                                        </div>:<span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span> }
                                </>
                            }
                        </div>
                    </div>
                        </>
                    );
                })}
            </div>
        </>
    );
}

export default VisualInspectionItemsList;